
import React, {useRef, useEffect} from 'react';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore } from "@100mslive/react-sdk";

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
const NDAER_URL=  "http://localhost:3001/documents"
const Guest_vid ="https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"

//  let el2
function AddContactModal(props) {
    // const username = props.user   
    const username = JSON.parse(window.localStorage.getItem('cur_user')) 
    // const QR_user = JSON.parse(window.localStorage.getItem('QR_user'))?JSON.parse(window.localStorage.getItem('QR_user')):'';
    // const QR_meeting_id = JSON.parse(window.localStorage.getItem('QR_meeting_id'))?JSON.parse(window.localStorage.getItem('QR_meeting_id')):'';
    // const QR_event_id = JSON.parse(window.localStorage.getItem('QR_event_id'))?JSON.parse(window.localStorage.getItem('QR_event_id')):''; 
    // window.localStorage.setItem('cur_user',JSON.stringify(username))
    console.log("AddContactModal username: ", username)
  function routeHome(){
    window.location.href = `/`
  }

  const connect_modal = document.getElementById('connect-modal-container')
  function closeModal(e){
      console.log("Close modal!....in the future..")
        connect_modal.classList.toggle('hide-connect-modal')
    //  e.target.value

    
  }
  function confirmContact(){
    console.log("Add to contacts!....in the future..")
    closeModal()
  }
  console.log("process.env.NDAER_URL",process.env.NDAER_URL)
  // }, []);
//   let qrLinkClass = `qr-link hub-button blink-faster`
    // function getUserInfo(){
   
    // if(props.view == 'hub'){tag = 'connect with'}
    // else{tag ='enter'}
    // return(
    //     <>
    //     <h4>scan to {tag}:</h4>
    //     </>
    // )
    // }
    return (
        <>
        <div className="qr-modal-container" id="connect-modal-container">
            {/* <h3>connect with:</h3>  */}
             <div className="qr-modal-header blink-slower">
                &nbsp;
             </div>
            <div className='qr-modal-content-wrap'>
                {/* <div className='h-button-wrap'> */}
               
                {/* </div> */}
            </div>
            <div className='qr-modal-footer'>
                
                
                <h3>{props.QR_Type === 'user' ?'connect with:':`enter ${props.QR_Type} :`}</h3>
                <h2>{props.QR_Data}</h2>
                {/* <h2>{props.QR_event_id?props.QR_event_id:''}</h2> */}
            </div>
            <div className='vote-modal-bottom'>
                        <div onClick={(e)=>{closeModal(e)}} type="submit" name ='deny' className='vote-submit-btn blink btn-spc cancel' key="vt-cncl-btn">deny</div>
                        <div onClick={(e)=>{confirmContact(e)}} type="submit" name ='accept' className='vote-submit-btn blink btn-spc' key="vt-cnf-btn">accept</div>
                    </div>
        
      </div>
      </>

  );
}
export default AddContactModal; 